/**
 * Replace $word$ with <span class="className" >word</span>
 *
 * @param {string} text
 * @param {string} className
 * @returns {string}
 */
function textReplacer(text, className) {
    const regex = /\$(.*?)\$/g;
    return text.replace(regex, `<span class="${className}">$1</span>`);
}

/**
 * Checks if a given string is a valid URL/link.
 *
 * @param {string} str - The string to be checked.
 * @returns {boolean} Returns true if the string is a valid URL, false otherwise.
 */
function isLink(str) {
    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlPattern.test(str);
}

/**
 * Remove $ symbol from titles
 * 
 * @param {string} sentence 
 * @returns {string}
 */
function removeSymbol(sentence) {
    const regex = /\$.*?\$/g;
    return sentence.replace(regex, '');
}

/**
 * Get the stroke color of an svg
 * 
 * @param {string} url - SVG url
 * @returns {Promise<string>} - A promise that resolves into a string that represents the SVG stroke color
 */
function getSvgStrokeColor(url) {
    return fetch(url)
        .then((response) => response.text())
        .then((rawStr) => new window.DOMParser().parseFromString(rawStr, 'image/svg+xml'))
        .then((parsedSvgElement) => parsedSvgElement.querySelector('path').getAttribute('stroke'));
}

/**
 * Checks to see if a string matches this patter (STRING)
 * 
 * @param {string} str
 * @returns {boolean}
 */
function isTag(str) {
    return (str.startsWith('(') && str.endsWith(')'));
}

/**
 * Remove ( and ) symbols from string
 * 
 * @param {string} str
 * @returns {string}
 */
function getTagValue(str) {
    const regex = /\(|\)/g;
    return str.replace(regex, '');
}

/**
 * Formats the stats data and returns it in an array format
 *
 * @param {string} stats - The unformated stats string
 * @returns {Array} - An array of objects containing the formatted stat data
 */
function formatStats(stats) {
    const statsArray = stats.split('\\n\n');
    const formattedArray = [];

    let index = 0;
    while (index < statsArray.length) {
        formattedArray.push({
            title      : statsArray[index],
            description: statsArray[index + 1],
            stat       : statsArray[index + 2],
        });
        index += 3;
    }

    return formattedArray;
}

export {
    textReplacer, isLink, removeSymbol, getSvgStrokeColor, isTag, getTagValue, formatStats,
};
